import React, {Component} from 'react';
import Table from 'react-bootstrap/Table';

//cal rebre a través de props: dades amb els valors escrits a continuació

class TaulaGeneral extends Component {	
    render() {          
     return (
      <Table striped bordered hover responsive variant="dark" size="sm">
        <tbody>
            <tr>
                <td className="negreta">Total votants</td>
                <td>{this.props.dades.totalVotants.toLocaleString('en').replace(/\,/g, '.')}</td>
                <td>{this.props.dades.totalVotants_per.toString().replace(/\./g, ',')} %</td>
            </tr>
            <tr>
                <td className="negreta">Abstenció</td>
                <td>{this.props.dades.abstencio.toLocaleString('en').replace(/\,/g, '.')}</td>
                <td>{this.props.dades.abstencio_per.toString().replace(/\./g, ',')} %</td>
            </tr>
            <tr>
                <td className="negreta">Vots nuls</td>
                <td>{this.props.dades.votsNul.toLocaleString('en').replace(/\,/g, '.')}</td>
                <td>{this.props.dades.votsNul_per.toString().replace(/\./g, ',')} %</td>
            </tr>
            <tr>
                <td className="negreta">Vots en blanc</td>
                <td>{this.props.dades.votsBlanc.toLocaleString('en').replace(/\,/g, '.')}</td>
                <td>{this.props.dades.votsBlanc_per.toString().replace(/\./g, ',')} %</td>
            </tr>
        </tbody>
      </Table>
      );
    }
  }

  export default TaulaGeneral;